<template>
  <div class="tutorial-left">
    <h1>{{ content.title }}</h1>
    <div class="description-container">
      <p v-if="content.description">
        {{ content.description }}
      </p>
      <ul v-else-if="content.topics">
        <li
          v-for="(topic, rowIndex) in content.topics"
          :key="rowIndex"
          :class="topic.color + '-color'"
        >
          {{ topic.label }}
        </li>
      </ul>
      <tutorial-button
        :action="action"
        :content="content.cta"
      />
    </div>
    <img
      ref="arrowTutorial"
      class="arrow"
      :src="content.arrow"
      alt="arrow"
    >
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialLeft',
  mixins: [mixin]
}
</script>

<style lang="scss">
.tutorial-left {
  z-index: 9004;
  position: fixed;
  top: 34%;
  left: 34%;
  width: 50%;

  .arrow {
    position: fixed;
    transform: translateY(-104%) translateX(calc(110% + 8em));
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    /* IE10+ */
    .arrow {
      transform: translateY(-109%) translateX(185%);
    }
  }

  .white-color {
    color: #E5E5E5;
    &::before {
      content: "•";
      color: #E5E5E5;
      padding-right: 10px;
    }
  }

  .gray-color {
    color: #7A7A7A;
    &::before {
      content: "•";
      color: #7A7A7A;
      padding-right: 10px;
    }
  }

  .description-container {
    width: 100%;

    ul {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      line-height: 26px;
      font-size: 18px;
      list-style: none;
    }
  }
}
</style>
